import { useEffect } from 'react';
import { isProduction } from 'utils/env/isProduction';

export const KnowledgeBase = () => {
	useEffect(() => {
		window.location.replace(
			isProduction ? '/panel/knowledge-base' : `${process.env.REACT_APP_PANEL_HOST}/knowledge-base`
		);
	}, []);

	return null;
};
export default KnowledgeBase;
